var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"clock",class:{shanghaitech:_vm.shanghaitech}},[_c('div',{staticClass:"date ecnu"},[_vm._v(_vm._s(_vm.date)+" "),(_vm.shanghaitech)?_c('span',[_vm._v(_vm._s(_vm.time))]):_vm._e()]),(!_vm.ecnu && !_vm.shanghaitech)?_c('div',{staticClass:"time"},[_vm._v(_vm._s(_vm.time))]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }